import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import ApiService from './api.service';
import { storage } from '../firebase/config';

/**
 * Perfil propio — PATCH /api/usuarios/me/perfil + avatar en Storage.
 */
class UserProfileService extends ApiService {
  constructor() {
    super('/usuarios');
  }

  async updateMyProfile(payload) {
    const { data, status } = await this.patch('/me/perfil', payload);
    if (status >= 400 || data?.success === false) {
      throw new Error(data?.message || 'No se pudo actualizar el perfil');
    }
    return data?.data || data;
  }

  async uploadAvatar(orgId, uid, file) {
    if (!orgId || !uid || !file) {
      throw new Error('Datos insuficientes para subir avatar');
    }
    const ext = file.type === 'image/png' ? 'png' : 'jpg';
    const contentType = file.type === 'image/png' ? 'image/png' : 'image/jpeg';
    const storageRef = ref(storage, `users/${orgId}/${uid}/avatar.${ext}`);
    await uploadBytes(storageRef, file, { contentType });
    return getDownloadURL(storageRef);
  }
}

export default new UserProfileService();
